<!--
================================================
Un composant affichant une section contenant les tarifs de l'application
⚠️ Ce composant a été copié depuis le site nuxt et adapté pour la pwa
http://localhost:8080/fr/adobe/subscription
================================================
-->

<!------------------------------------------------
+++++++++++++++++++++ HTML +++++++++++++++++++++++
-------------------------------------------------->
<template>
  <div class="plansBlocsSectionComp" v-bind:class="{'darkMode':themeToDisplay=='dark'}">

      <div class="columns is-centered">
        <div class="cycleSelector">
          <div class="field">

            <label :class="{'isActive':!billPerYear}" class="cycle month"
                   @click="billPerYear=false">{{ $t('tarificationMensuelle') }}</label>

            <input id="billingCycle" type="checkbox" name="switchExample" class="switch is-rounded" checked="checked"
                   v-model="billPerYear" @click="billPerYear ? billPerYear = false : billPerYear = true">

            <label :class="{'isActive':billPerYear}" class="cycle year" @click="billPerYear=true">{{ $t('tarificationAnnuelle') }}
              <span class="gift"> 🎁 {{ $t('xMoisGratuits', {'count': 2}) }}  </span>
            </label>
          </div>
        </div>

      </div>

      <div class="columns is-centered">

        <div v-if="componentIsReady" class="column plan" v-for="(plan,name,index) in i10nPlans">
          <plan-bloc :bill-per-year="billPerYear"
                     :preparedPriceHierarchy="preparedPriceHierarchy"
                     :stripe-checkout-session-id="stripeCheckoutSession.id" :stripeCustomerEmail="stripeCustomerEmail"
                     :active-stripe-price-id="activeStripePriceId" :plan="plan"></plan-bloc>

        </div>


      </div>

      <div class="enterpriseLine">
        {{ $t('plusDe100CollaborateursContactezNous') }}
        <a v-bind:href="'mailto:'+ supportEmail">{{$t('contactezNous')}}</a>
      </div>

      <div class="postIt">
        <font-awesome-icon :icon="['fas', 'globe-americas']" class="icon globe"/>
        <div class="titleLine">{{ $t('AvecCronocloudVousProtégezLaPlanète') }}</div>
        <p v-html="$t('pourChaqueAbonnementPremiumNousReversons1Pourcent')">
        </p>
        <a href="https://climate.stripe.com/VPuh1q" target="_blank" >
          {{ $t('enSavoirPlus') }}
          <font-awesome-icon :icon="['fas', 'external-link-alt']" class="icon externalLink"/>
        </a>

      </div>

  </div>
</template>

<!------------------------------------------------
+++++++++++++++++++++ SCRIPT ++++++++++++++++++++++
-------------------------------------------------->
<script>

import {mapState} from 'vuex'
import planBloc from "@/components/pricing/planBloc";
import i18nMixin from "@/mixins/i18nMixin";

export default {
  name: "plansBlocsSectionComp",

  props: {
    // pour typage voir :https://fr.vuejs.org/v2/guide/components-props.html#Types-des-props
    // text: String, // texte à afficher dans le bouton
    stripeCustomerEmail:{
      type: String,
      // required: true,

    },
    stripeCheckoutSession: { // un objet stripe checkout session https://stripe.com/docs/api/checkout/sessions/create
      type: Object,
      required: true

    },

    activeStripePriceId:{ // Le price id de la subscription en cours
      type: String,
      required: true
    }

  },
  mixins: [i18nMixin],
  data: function () {
    return {
      supportEmail: 'mailto:'+ process.env.VUE_APP_SUPPORT_EMAIL, // lien mailto vers le support
      locale: this.$i18n.locale,
      billPerYear: false, // true si le cycle de facturation à afficher est annuel (sinon mensuel)

      componentIsReady : false, // indique quand le composant est prêt à être affiché (tarifs chargés)

      // i10nPlans: null,
      i10nPlans: [], // Array contenant les plans récupérés depuis le backend
      preparedPriceHierarchy: [], // Un Array contenant les plans classés hiérarchiquement

    }
  },

  components: {planBloc},
  computed: {
    ...mapState({
      themeToDisplay: state => state.app.themeToDisplay
    }),

  },

  watch: {

    billPerYear: function() {

      let cycle;
      this.billPerYear === true ? cycle = 'year' : cycle = 'month',
      this.$router.push({ query: { ...this.$route.query, cycle: cycle}});

    }
  },
  methods: {
        /*
         Effectue une requête pour récupérer les tarifs depuis le backend
         */
    getPlansSpecs() {
      let self =this;
      return self.$http
          // .get("/public/s/plans?locale="+self.locale)
          .get("/public/s/plans?pgr="+self.planGroup4Locale)
          .then(function (response) {
            self.$store.commit('UpdateGlobalNotificationCompVisibility', false) // masquage d'une éventuelle erreur
            self.i10nPlans = response.data
            self.preparePriceHierarchy()
            self.componentIsReady = true;
            self.$root.$emit('plans_spec_loaded')
            return {
            }
          })
          .catch(function (error) {
            let errorCode = '0057'
            let errorMsq = 'error fetching plans'
            self.showGlobalErrorNotif(self,errorCode)
            self.$gtag.exception({'description': 'error '+errorCode + ' | '+errorMsq, 'fatal': false})
            self.$mixpanel.track('global error displayed', {"id":errorCode, "detail": errorMsq})
            self.$sentry.captureMessage(`Error ${errorCode} > ${errorMsq} : ${error}`, 'error')

          })
    },

    /**
     * Définit un array (pour la culture en cours) contenant les pricesId des plans classsé par cycle
     *    ex : {
     *          month : [ plan1priceId, plan2PriceId, plan3PriceId],
     *          year : [ plan1priceId, plan2PriceId, plan3PriceId]
     *         }
     *
     * Cet array est utile dans planBloc.vue
     * @see planBloc.vue getPriceHierarchy()
     *
     * Note : Le classement est une simple boucle sur les tarfis puisque le backend les retourne selon 2 critères de classement :  - orderBY Id ASC et - orderBy priceMonth ASC
     */
    preparePriceHierarchy(){
      let hierarchy = {
        [this.locale] : {
          month: [],
          year: []
        }
      }
      let self = this
      this.i10nPlans.forEach(function (plan) {
        hierarchy[self.locale].month.push(plan.stripeMonthPriceId)
        hierarchy[self.locale].year.push(plan.stripeYearPriceId)
      });

      this.preparedPriceHierarchy = hierarchy
    }
  },

  mounted: function () {

    // chargement des tarifs
    this.getPlansSpecs()

    // synchronisation du query param gérant le cycle de facturation
    if(this.$route.query.cycle != null){
      if (this.$route.query.cycle ==='year'){
        this.billPerYear=true
      }
      else if (this.$route.query.cycle ==='month'){
        this.billPerYear=false
      }

    }
  }

}
</script>

<!------------------------------------------------
+++++++++++++++++++++ CSS ++++++++++++++++++++++++
-------------------------------------------------->
<style scoped lang="scss">
@import "../../assets/css/globalVar";
@import "../../assets/css/bulmaResponsiveDep";

.plansBlocsSectionComp {
  //////////////////////////////////////////
  // LIGHT THEME ///////////////////////////

  .column.plan {
    margin: 0 1rem;
    @include touch {
      margin: 0;
    }
  }

  .cycleSelector {
    //border: dashed 1px $lightGreen;
    margin: 4rem auto 3rem;
    padding: 0 1rem;
    font-weight: bold;
    color: darken(#c2cab1, 5%);
    @include touch {
      margin: 3rem auto;
      display: block;

    }

    .switch[type=checkbox]:checked + label:before {
      //background: red !important;

    }

    .switch[type=checkbox] + label:before {
      background: $brandFourth !important;
    }


    label {
      font-size: .9rem;
      cursor: pointer;
      margin: 0;

      color: #c2cab1;
      position: relative;

      @include touch {
        display: block;
        margin-bottom: .4rem;
      }

      &.isActive {
        //font-weight: bold;
        color: darken($brandFourth, 10%);

        .gift {
          opacity: 1;
        }
      }

      .gift {
        opacity: .6;
        //position: absolute;
        top: 1.6rem;
        right: 0rem;
        background-color: rgba(255, 255, 255, 0.5);
        padding: .2rem .5rem;
        border-radius: .4rem;
        font-size: .75rem;
        margin-left: .2rem;
        color: $brandPremium;
        @include touch {
          left: 0;
          background-color: transparent;
        }

      }
    }
  }

  .enterpriseLine {
    text-align: center;
    font-weight: bold;
    color: $brandThird;
    font-family: $mainFont2;
    padding-bottom: 2rem;
    margin: 3rem auto 0;

    a {
      //color: $brandThird;
      text-decoration: underline;
      text-decoration-width: 3px;

      &:hover {
        color: $brandBlue;
      }
    }
  }

  .postIt {
    transform: rotate(-3deg);

    margin: 2rem auto 0;
    display: flex;
    justify-content: center;
    flex-direction: column;
    padding: 1.3rem;
    position: relative;
    //right: -5rem;
    //bottom: -15rem;
    z-index: 11; // pour passer par dessus faqSection
    background-color: #fdf9cf;
    width: 300px;
    height: 300px;
    box-shadow: 0 0 .6rem #ccc;
    color: $brandThird;
    font-size: .9rem;

    transition: box-shadow .25s ease-in-out, transform .3s;

    @include touch {
      position: relative;
      top: 1rem;
      bottom: 0;
      left: .5rem;
    }

    &:hover {
      box-shadow: 0 .7rem .9rem #ccc;
      transform: rotate(2deg);

    }

    .icon {
      $size: 3.5rem;
      height: $size;
      width: $size;
      margin-bottom: .5rem;
      color: $lightGreen;
      align-self: center;
      //position: absolute;
      //top: 1rem; right: 1rem;
      //z-index: -1;
      &.externalLink {
        $size: .5rem;
        height: $size;
        width: $size;
        color: $brandBlue;
        margin-left: .1rem;
        vertical-align: bottom;
        line-height: 1rem;
        //font-size: .9rem !important;
      }
    }

    .titleLine {
      font-size: 1.1rem;
      color: $brandThird;
      font-weight: bold;
      font-family: $mainFont2;
    }

    p {
      margin: .7rem auto;
    }

    a {
      font-size: .85rem;
      color: $brandBlue;
      font-weight: bold;
    }
  }

  /////////////////////////////////////////
  // DARK THEME ///////////////////////////
  &.darkMode {
    .cycleSelector{
      label{

      color: #666;

        &.isActive {
          color: $darkContrastTxt;
        }
        .gift{
          color: $darkContrastTxt;
          opacity: 1;
          background-color: $darkBg2;
        }
      }

      .switch[type=checkbox] + label:before {
        background: $darkBg2 !important; ;
      }
    }
    .enterpriseLine {
      color: $darkContrastTxt;
      a{color: $darkContrastTxt}
    }
    .postIt{
      box-shadow: none;
      //.icon.globe{color: $dakr}
    }
  }
}


</style>
